import Marquee from "react-fast-marquee";
import { Star } from "lucide-react";

const ITEMS = [
  "Electrician", "Plumber", "Carpenter", "AC Repair", "Deep Cleaning", "Barber", "Beauty & Makeup",
  "30-min arrival", "Verified partners", "Upfront pricing", "4.8★ rated", "8 Bihar cities",
];

export default function Ticker() {
  return (
    <section className="relative border-y border-azo-border bg-azo-primary text-white py-4 overflow-hidden" data-testid="marquee-ticker">
      <Marquee speed={42} gradient={false} autoFill>
        {ITEMS.map((t, i) => (
          <span key={i} className="mx-6 inline-flex items-center gap-3 text-lg sm:text-xl font-heading font-semibold tracking-tight">
            {t}
            <Star size={14} className="fill-white/70 text-white/70" />
          </span>
        ))}
      </Marquee>
    </section>
  );
}
